const taskTable = {
	title: 'Úkoly k předání',
	taskId: 'ID úkolu',
	taskType: 'Typ úkolu',
	subType: 'Podtyp / Důvod kontaktování',
	deadline: 'Termín splnění',
	psNumber: 'Číslo PS',
	clientName: 'Klient',
	taskParametersTitle: 'Nové parametry úkolu',
};

const userTable = {
	userTableTitle: 'Výsledek vyhledání uživatele',
	name: 'Jméno',
	acquirerNumber: 'Seznam získatelských čísel',
	userLogin: 'Login uživatele',
	profession: 'Profese',
};

const form = {
	deadlineDate: 'Nový termín splnění',
	forward: 'Předat',
};

const dialogs = {
	requiredFields: 'Alespoň jedno z povinných kritérií musí být vyplněno.',
	noUserSelected: 'Nebyl vybrán řešitel.',
};

export default {
	...taskTable,
	...userTable,
	...form,
	...dialogs,
};
